import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

export const Header = styled.header`
  height: 30px;
  position: relative;
  color: ${getThemeColor('foreground')};
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  padding-left: 5px;

  html[lang=ta] & {
    font-size: 12px;
  }

  @media all and (orientation: portrait) {
    [lang=ru] [data-e2e=last-round-stats] & {
      font-size: 11px;
    }
  }

  @media (max-width:961px)  {
    padding-left: unset;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  padding: 0 10px;
  justify-content: start;
  height: calc(100% - 20px);
`;

export const sectionIconClassName = css`
  > svg {
    fill: ${getThemeColor('foreground')};
  }
`;
